export default "__VITE_ASSET__89053731__"